import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Headroom from 'react-headroom';
// FIXME: When we merge all these projects into 1 application, we should
// move browser detection as high up in the application as possible in
// order to prevent additional calls to detect() as users navigate
// from page to page.
import { detect } from 'detect-browser';
import {
  withRouter,
} from 'react-router-dom';
import {
  ExtendedBox,
  ExtendedFlex,
  HeaderNav,
  ClickableLogo,
  HeaderHamburger,
} from '../coreui';
import withPortal from '../withPortal';

import authActions from '../auth/actions';

import HeaderMobileMenu from './components/HeaderMobileMenu';
import HeaderUserMenu from './components/HeaderUserMenu';
import HeaderMenu from './components/HeaderMenu';

const headerRoot = typeof document !== 'undefined' ? document.getElementById('react-header') : null;

class Header extends Component {
  constructor(props) {
    super(props);
    const browser = detect();

    this.state = {
      mobileMenuVisible: false,
      browser: browser.name === 'ie' && browser.version === '11.0.0' ? 'ie11' : 'notie11',
      isLimitedNav: false,
      isRegFlow: false,
    };

    this.hamburgerOnClickHandler = this.hamburgerOnClickHandler.bind(this);
    this.setNavTypes = this.setNavTypes.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.setNavTypes(this.props.location.pathname);

    this.setState({
      mobileMenuVisible: false,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setNavTypes(nextProps.location.pathname);
    }
  }

  setNavTypes(pathname) {
    const limitedPaths = ['/invest/'];
    const regFlowPaths = ['/user/register'];

    const isLimitedNav = limitedPaths.reduce(
      (accum, item) => {
        return pathname.includes(item) ? true : accum;
      }, false,
    );
    const isRegFlow = regFlowPaths.reduce(
      (accum, item) => {
        return pathname.includes(item) ? true : accum;
      }, false,
    );
    this.setState({
      isLimitedNav,
      isRegFlow,
    });
  }

  hamburgerOnClickHandler() {
    this.setState((state) => ({
      mobileMenuVisible: !state.mobileMenuVisible,
    }));
  }

  handleLogout(e) {
    e.preventDefault();
    this.props.userLogoutRequested();
    this.setState({
      mobileMenuVisible: false,
    });
  }

  render() {
    const { mobileMenuVisible, browser, isLimitedNav, isRegFlow } = this.state;
    const { items, user, initialized } = this.props;

    return (
      <>
        <Headroom style={{ zIndex: 3 }}>
          <HeaderNav>
            <ExtendedBox
              boxSizing="border-box"
              display={['block', 'block', 'block', 'none']}
              w="1px"
              flex="1"
            />
            {
              !isRegFlow &&
              <HeaderHamburger
                display={['block', 'block', 'block', 'none']}
                mobileMenuVisible={mobileMenuVisible}
                handleClick={this.hamburgerOnClickHandler}
                flex="1"
              />
            }
            <ExtendedFlex
              flex="1"
              justify={['center', 'center', 'center', 'flex-start']}
            >
              <ClickableLogo
                logoColor="black"
                w={['auto']}
              />
            </ExtendedFlex>
            <HeaderMenu
              items={items}
              browser={browser}
              isLimitedNav={isLimitedNav || isRegFlow}
            />
            {
              initialized &&
              <HeaderUserMenu
                browser={browser}
                isLimitedNav={isLimitedNav}
                isRegFlow={isRegFlow}
                user={user}
                display={['none', 'none', 'block']}
                zIndex={9993}
                handleLogout={this.handleLogout}
                userSwitch={user.userSwitch}
              />
            }
            {
              // Add in a spacer element for use before the app is initialized.
              !initialized &&
              <ExtendedBox
                flex="1"
              />
            }
          </HeaderNav>
        </Headroom>
        <HeaderHamburger
          mobileMenuVisible={mobileMenuVisible}
          handleClick={this.hamburgerOnClickHandler}
          visibility={mobileMenuVisible ? 'visible' : 'hidden'}
          position="fixed"
          display={['block', 'block', 'block', 'none']}
        />
        <HeaderMobileMenu
          mobileMenuVisible={mobileMenuVisible}
          closeMenu={this.hamburgerOnClickHandler}
          handleLogout={(e) => {
            this.handleLogout(e);
            this.hamburgerOnClickHandler(e);
          }}
          items={items}
          user={user}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  items: state.header.items,
  user: state.header.user,
  initialized: state.header.initialized,
});

const mapDispatchToProps = (dispatch) => ({
  userLogoutRequested: () => {
    dispatch(authActions.userLogoutRequested());
  },
});

Header.propTypes = {
  items: PropTypes.array,
  user: PropTypes.object,
  location: PropTypes.object,
  userLogoutRequested: PropTypes.func,
  initialized: PropTypes.bool,
};

export default withPortal(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Header)),
  headerRoot,
);
